export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const PAYMENT_ENDPOINT = process.env.REACT_APP_PAYMENT_ENDPOINT;

export const APP_NAME = 'benefit';
